export enum OperacaoCrud {
    INSERT = "inserting",
    UPDATE = "updating",
    REMOVER = "removendo",
    RETRIEVE = "consultando",
}

export const NEW = "[new]";
